<div class="row page-header">
    <div class="col-12">
        <h1>Job Ownership Templates <small>Manage job ownership templates and thier items</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        style="height: 300px"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        (selectionChanged)="filterItems()"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="itemGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="itemGrid"
                            [canEdit]="grid.selectedItem && canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="itemGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridItem"
                        #gridItem
                        appAutoSize
                        (initialized)="itemGrid.initialize(gridItem)"
                        (destroy)="itemGrid.destroy()"
                        [itemsSource]="itemGrid.view"
                    >
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Auto-Assign To'"
                            [binding]="'assignedRole'"
                            [dataMap]="roleMap"
                            [width]="200"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Order'" [binding]="'order'" [width]="'*'"></wj-flex-grid-column>-->
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
